export enum enFormMode {
    fmInsert = 1,
    fmEdit = 2,
    fmDetail = 3
}
